/** @jsx jsx */

import { jsx, Flex, Text, IconButton } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import PropTypes from "prop-types"

import Link from "./Link"

export const BottomNav = ({ currentPage, episodeThumbnails }) => {
  return (
    <Flex
      sx={{
        my: [0, 4],
        maxWidth: ["100vw", "800px", "800px"],
        mx: "auto",
        justifyContent: "center",
        position: ["fixed", "inherit", "inherit"],
        bottom: [0, "auto"],
        background: ["black", "inherit"],
        py: [2, 0],
        zIndex: 1,
      }}
    >
      {episodeThumbnails.map((thumbnail) => (
        <Link
          key={thumbnail.episodeNumber}
          to={`/${thumbnail.episodeNumber}`}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContents: "center",
            alignItems: "center",
            mx: [0, 3],
            textDecoration: "none",
            color: "gray",
          }}
        >
          <GatsbyImage
            sx={
              thumbnail.episodeNumber === currentPage
                ? {
                    borderStyle: "solid",
                    borderColor: "#00DC64",
                    borderWidth: "3px",
                  }
                : {}
            }
            image={thumbnail.imageData}
            alt={thumbnail.episodeNumber}
          />
          <Text
            sx={{
              mt: 1,
              ...(thumbnail.episodeNumber === currentPage
                ? { color: "#00DC64" }
                : {}),
            }}
          >
            Ep. {thumbnail.episodeNumber}
          </Text>
        </Link>
      ))}
    </Flex>
  )
}

BottomNav.propTypes = {
  episodeThumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      episodeNumber: PropTypes.number,
      imageData: PropTypes.object,
    })
  ),
}
